"use strict";

"production" === process.env.NODE_ENV ? module.exports = require("./js/react-notifications.prod.js") : module.exports = require("./js/react-notifications.dev.js");